import React from 'react'
import PropTypes from 'prop-types'
import UrlTo from 'commons/js/util/UrlTo'
import { injectIntl } from 'react-intl'
import messages from './messages'
import CouponPackSelector from './CouponPackSelector'

const goToShop = (option, price) => {
    // eslint-disable-next-line xss/no-location-href-assign
    window.location.href = UrlTo.get('merchant/shop', {option: option.value, price})
}

class CouponPackSelectorMapper extends React.Component {
    getCouponOptionsDictionary (options) {
        return JSON.parse(options).map((option) => ({
            label: this.props.intl.formatMessage(messages.coupons),
            value: `${option}`,
        }))
    }

    static propTypes = {
        couponPrice: PropTypes.string.isRequired,
        couponOptions: PropTypes.string.isRequired,
        couponCurrency: PropTypes.string.isRequired,
        intl: PropTypes.object.isRequired,
    }

    render () {
        const { couponOptions, couponPrice, couponCurrency } = this.props
        return (
            <CouponPackSelector
              couponOptions={this.getCouponOptionsDictionary(couponOptions)}
              couponPrice={parseFloat(couponPrice)}
              couponCurrency={couponCurrency}
              goToShop={goToShop} />
        )
    }
}

export default injectIntl(CouponPackSelectorMapper)
